"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KeyCodes = function KeyCodes() {
    _classCallCheck(this, KeyCodes);

    this.keys = {
        "KEY_TAB": 9,
        "KEY_ENTER": 13,
        "KEY_ESCAPE": 27,
        "KEY_SPACE": 32,
        "KEY_LEFT": 37,
        "KEY_UP": 38,
        "KEY_RIGHT": 39,
        "KEY_DOWN": 40
    };
};

exports.default = KeyCodes;